import React from 'react';
import * as consts from 'config/consts';
import Icon from 'components/commons/icon/Icon';
import { GetUserResut } from 'config/api';

const securityCompanies = [
  {
    brokerID: consts.MONOBrokerIds.SBI証券,
    name: 'SBI証券',
    url:
      'https://minkabu.jp/hikaku/redirect_tw/sbi.html?utm_source=tw&utm_medium=securities_list&utm_campaign=',
  },
  {
    brokerID: consts.MONOBrokerIds.楽天証券,
    name: '楽天証券',
    url:
      'https://minkabu.jp/hikaku/redirect_tw/rakuten.html?utm_source=tw&utm_medium=securities_list&utm_campaign=',
  },
  {
    brokerID: consts.MONOBrokerIds.松井証券,
    name: '松井証券',
    url:
      'https://minkabu.jp/hikaku/redirect_tw/matsui.html?utm_source=tw&utm_medium=securities_list&utm_campaign=',
  },
  {
    brokerID: consts.MONOBrokerIds.三菱UFJeスマート証券,
    name: '三菱UFJ eスマート証券',
    url:
      'https://minkabu.jp/hikaku/redirect_tw/kabucom.html?utm_source=tw&utm_medium=securities_list&utm_campaign=',
  },
];
const securityRankingUrl =
  'https://minkabu.jp/hikaku/lp/total_ranking_tw.html?utm_source=tw&utm_medium=securities_list&utm_campaign=';

export const SecuritiesCompanyList = ({
  user,
}: {
  user: GetUserResut | undefined;
}) => {
  const securities = securityCompanies.map((item, index) => {
    return (
      <div className="ui-border-b p-2" key={index}>
        <div className="ml-4 mr-2 flex items-center py-2">
          <div className="flex-grow">
            <div className="text-lg font-bold">{item.name}</div>
          </div>
          <a
            id="securityAccounts_accoutOpening"
            href={`${item.url}${user?.ID}`}
            target="_blank"
            rel="noopener noreferrer">
            <div className="flex py-1 px-2 border rounded border-link text-link bg-white">
              <span className="text-sm">口座開設</span>
              <Icon name="external-link" className="ml-2 text-lg" />
            </div>
          </a>
        </div>
      </div>
    );
  });
  return (
    <div className="ui-card mt-8">
      <div className="p-4 border-b border-gray-200 font-bold">
        証券口座をお持ちでない方
      </div>
      {securities}

      <div className="m-4 text-center">
        <a
          id="securityAccounts_ranking"
          className="text-link text-sm"
          href={`${securityRankingUrl}${user?.ID}`}
          target="_blank"
          rel="noopener noreferrer">
          ネット証券　総合ランキングを見る
        </a>
      </div>
    </div>
  );
};
